const CHUNK_RELOAD_KEY = "sporthouse:chunk-reload-at";
const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

export const isChunkLoadError = (error) => {
  const message = `${error?.name || ""} ${error?.message || ""}`;
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported module/i.test(message);
};

export const recoverFromChunkLoadError = (
  error,
  {
    storage = window.sessionStorage,
    reload = () => window.location.reload(),
    now = Date.now(),
  } = {},
) => {
  if (!isChunkLoadError(error)) return false;

  try {
    const lastReloadAt = Number(storage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (now - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) return false;

    storage.setItem(CHUNK_RELOAD_KEY, String(now));
    reload();
    return true;
  } catch {
    return false;
  }
};

